import React, { useState, useEffect } from 'react';
import { Transition } from "@headlessui/react";

const About = () => {

    const [images] = useState([
        "images/about/Image.webp",
        "images/about/Image (2).webp",
        "images/about/Image (3).webp",
        "images/about/Image (4).webp",
        "images/about/Image (5).webp",
        "images/about/Image (6).webp",
        "images/about/Image (7).webp",
    ]);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((currentIndex + 1) % images.length);
        }, 5000);

        return () => {
            clearInterval(interval);
        };
    }, [currentIndex, images.length]);

    return (
        <section id='about'>

            <div
                className="mx-auto max-w-screen-xl px-4 py-8 sm:py-12 sm:px-6 lg:py-16 lg:px-8"
            >
                <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-16">
                    <div
                        className="relative h-64 overflow-hidden rounded-lg sm:h-80 lg:order-last lg:h-full"
                    >
                        <Transition
                            show={true}
                            enter="transition-opacity duration-1000"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="transition-opacity duration-1000"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <img
                                alt={`${currentIndex + 1}`}
                                src={images[currentIndex]}
                                className="absolute inset-0 h-full w-full object-cover"
                            />
                        </Transition>
                    </div>

                    <div className="lg:py-24">
                        <h2 className="text-3xl font-bold sm:text-4xl">Experts in our Field</h2>

                        <p className="mt-4 text-gray-600">
                            At Maximum Contracting, we are your trusted experts in the Kitchener-Waterloo-Cambridge-Guelph region and surrounding areas of Southwestern Ontario for all your wet basement repair needs.
                            <br />
                            <br />
                            With over 17 years of expertise, we specialize in crack injection and waterproofing solutions to address water problems and foundation issues. Our dedicated team is committed to ensuring your home remains dry and free from moisture-related damage. We also handle various concrete repairs, including fixing minor foundation issues.
                            <br />
                            <br />
                            From leaky basement floors to foundation wall cracks, we've got you covered. With the arrival of spring rain and winter thaw, we're here to repair your leaky basement, whether it's leaking walls or floors. We offer a wide range of services, including internal and exterior waterproofing, weeping tile systems, sump pump replacements, and more.
                            <br />
                            <br />
                            Contact us today to get a quote, and trust us to solve your wet basement and concrete repair concerns. We're here to provide the service, quality, and workmanship you deserve.

                        </p>

                        <a
                            href="#contact"
                            className="mt-8 inline-block rounded bg-rose-600 px-12 py-3 text-md font-medium text-white transition hover:bg-rose-700 focus:outline-none "
                        >
                            Contact Us Now!
                        </a>
                    </div>
                </div>
            </div>


        </section>

    );
};

export default About;
